export const UMSSBlue = "#424266";
export const UMSSBlueDark = "#2c2ca8";
export const UMSSBlueLight = "#5a5a82";
export const UMSSGold = "#d28f5d";
export const UMSSGoldLight = "#a67149";
